import React from 'react';

/**
 * ConnectionHandle Component
 * 
 * Renders a "+" button for creating connections from regular task nodes.
 * Supports both drag (to connect) and click (to show menu).
 */
const ConnectionHandle = ({
  task,
  screenPos,
  onMouseDown,
  className = '',
  title,
  edge = 'bottom',
}) => {
  return (
    <div
      data-task-id={task.id}
      data-handle={edge}
      className={`handles-layer__connection-handle ${className}`.trim()}
      style={{
        left: screenPos.x,
        top: screenPos.y,
      }}
      title={title}
      onMouseDown={onMouseDown}
    >
      <svg width="32" height="32" viewBox="-16 -16 32 32">
        <circle r="16" fill="transparent" />
        <circle
          r="8"
          fill="#1a1a2e"
          stroke="rgba(255, 255, 255, 0.7)"
          strokeWidth="1.5"
          className="handles-layer__handle-circle"
        />
        <line
          x1="0" y1="-3.5" x2="0" y2="3.5"
          stroke="rgba(255, 255, 255, 0.9)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="-3.5" y1="0" x2="3.5" y2="0"
          stroke="rgba(255, 255, 255, 0.9)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default ConnectionHandle;

